import { render, staticRenderFns } from "./sajoLockDetail.vue?vue&type=template&id=266ab82f&scoped=true"
import script from "./sajoLockDetail.vue?vue&type=script&lang=js"
export * from "./sajoLockDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ab82f",
  null
  
)

export default component.exports